export const debounce = (callback, wait) => {
  let timeout
  return (...args) => {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => callback.apply(context, args), wait)
  }
}

export const replaceAll = (string, search, replace) => {
  return string.split(search).join(replace)
}

export const cleanRedirectUrl = (url) =>
  url.substring(0, 6) === '/blog/' ? url.substring(5) : url
